import BaseModelInstance from './base.model'
import { KnowledgebaseArticle as ModelDefinition } from './model-definitions'

class KnowledgebaseArticle extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default KnowledgebaseArticle
